export default __webpack_public_path__ + "static/media/ico_burofax.e707c74f.svg";